import { render, staticRenderFns } from "./Idp.vue?vue&type=template&id=6365cfe1"
import script from "./Idp.vue?vue&type=script&lang=js"
export * from "./Idp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports